module.exports = __webpack_public_path__ + "img/hr-rock-big-15.e1b27d8c.png";